module.exports = __webpack_public_path__ + "img/play.c8ae7cb6.png";